﻿interface Date {
    addDays(days: number): Date;

    toJSON(): string;

    toISODate(): string;
}

Date.prototype.addDays = function (days: number) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

Date.prototype.toJSON = function () {
    const tzoffset = (new Date()).getTimezoneOffset() * 60000;
    return (new Date(this.valueOf() - tzoffset)).toISOString().slice(0, -1);
};

Date.prototype.toISODate = function () {
    return `${this.getFullYear()}-${(`0${this.getMonth() + 1}`).slice(-2)}-${(`0${this.getDate()}`).slice(-2)}`;
};